export default __webpack_public_path__ + "static/media/warningIcon.f2fcecc8.svg";